module.exports = __webpack_public_path__ + "img/ml_steps.93c6123e.jpg";